// 该文件专门用于创建整个应用的路由器
import VueRouter from "vue-router";
//引入组件
import HomePage from "../components/HomePage.vue";
import PersonalInformation from "../components/assessment/PersonalInformation.vue";
import Questionnaire from "../components/assessment/Questionnaire.vue";
import CommonDescription from "../components/testItems/CommonDescription.vue";
import CommonTraining from "../components/testItems/CommonTraining.vue";
import SejueDescription from "../components/testItems/SejueDescription";
import Sejue from "../components/testItems/Sejue.vue";
import Phone from "../components/assessment/Phone.vue";
import Inform from "../components/assessment/Questionnaire_Inform.vue";
import checkReport from "../components/testItems/CheckReport.vue";
//创建并暴露一个路由器
export default new VueRouter({
  routes: [
    {
      path: "/",
      component: HomePage,
    },
    {
      path: "/personalInformation",
      component: PersonalInformation,
    },
    {
      path: "/questionnaire",
      component: Questionnaire,
    },
    {
      path: "/",
      component: Questionnaire,
    },
    {
      path: "/commonDescription",
      component: CommonDescription,
    },
    {
      path: "/sejueDescription",
      component: SejueDescription,
    },
    {
      path: "/commonTraining",
      component: CommonTraining,
    },
    {
      path: "/sejue",
      component: Sejue,
    },
    {
      path: "/phone",
      component: Phone,
    },
    {
      path: "/form",
      component: Inform,
    },
    {
      path: "/CheckReport",
      component: checkReport,
    },
  ],
});
